import { MetroLineNote } from "@/components/MetroLineNote";

// Country guides are a branch line into Place.
export const CountryGuidesLineNote = ({ testId = "country-guides-line" }) => (
  <MetroLineNote line="Country guides" colour="#2563EB" testId={testId} stops={[
    { label: "Place", to: "/cities/matcher", testId: `${testId}-to-place` },
  ]} />
);
